<!-- <ngx-invisible-recaptcha #captchaElem
                        [siteKey]="site_key"
                        (ready)="handleReady()"
                        (load)="handleLoad()"
                        (error)="handleError()"
                        (expire)="handleExpire()"
                        (success)="handleSuccess($event)"
                        [useGlobalDomain]="false"
                        [hl]="'iw'"
                        [type]="'image'"
                        [badge]="'bottomleft'"
                        [ngModel]="recaptcha"
                        [matDialogClose]="true"
                        [ngModelOptions]="{ standalone: false }"
                        aria-hidden="true"
                        
                        >
                    </ngx-invisible-recaptcha> -->
                    <ngx-invisible-recaptcha #captchaElem
                        [siteKey]="site_key"
                        (ready)="handleReady()"
                        (load)="handleLoad()"
                        (error)="handleError($event)"
                        (expire)="handleExpire($event)"
                        (success)="handleSuccess($event)"
                        [useGlobalDomain]="false"
                        [hl]="'iw'"
                        [type]="'image'"
                        [badge]="'bottomleft'"
                        [ngModel]="recaptcha"
                       
                        [ngModelOptions]="{ standalone: false }"
                       
                        >
                    </ngx-invisible-recaptcha>

